import React from 'react';
import { Menu, Box, IconButton, Tooltip } from '@mui/material';

const PRESETS = [
  { id: 'emoji:🦊', label: '🦊' },
  { id: 'emoji:🐼', label: '🐼' },
  { id: 'emoji:🐧', label: '🐧' },
  { id: 'emoji:🦁', label: '🦁' },
  { id: 'emoji:🐨', label: '🐨' },
  { id: 'emoji:🐸', label: '🐸' },
  { id: 'emoji:🍽️', label: '🍽️' },
  { id: 'emoji:🌮', label: '🌮' },
];

export default function AvatarPicker({ anchorEl, open, onClose, onSelect }) {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      PaperProps={{
        sx: {
          backgroundColor: '#0f172a',
          color: '#fff',
          borderRadius: '12px',
          p: 1,
        },
      }}
    >
      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(4, 44px)', gap: 1, p: 0.5 }}>
        {PRESETS.map((p) => (
          <Tooltip key={p.id} title="Elegir avatar">
            <IconButton
              size="small"
              onClick={() => { onSelect?.(p.id); onClose?.(); }}
              sx={{
                width: 44,
                height: 44,
                borderRadius: '50%',
                bgcolor: 'rgba(255,255,255,0.06)',
                '&:hover': { bgcolor: 'rgba(255,255,255,0.12)' },
                color: '#fff',
              }}
            >
              <span style={{ fontSize: 22 }} aria-hidden>{p.label}</span>
            </IconButton>
          </Tooltip>
        ))}
      </Box>
    </Menu>
  );
}
